import axios from 'axios';
import { defaultRequestInterceptorFail, defaultRequestInterceptorSuccess, defaultResponseInterceptorFail, defaultResponseInterceptorSuccess } from './axiosInterceptors';

const axiosInstance = axios.create({});

axiosInstance.interceptors.request.use(defaultRequestInterceptorSuccess, defaultRequestInterceptorFail);
axiosInstance.interceptors.response.use(defaultResponseInterceptorSuccess, defaultResponseInterceptorFail);

export default axiosInstance;
